define(["./temperatureModule", "angular", "lodash"], function (module, angular, _, d3) {
    "use strict";
    return module.controller("MonitoringTemperatureController", [
        "$scope",
        "$translate",
        "monitoringService",
        "trackingService",
        "$q",
        "$stateParams",
        "$interval",
        "$filter",
        "loadingService",
        "remoteExceptionHandler",
        "monitoringQueryService",
        "spreadsheetExportService",
        function ($scope, $translate, monitoringService, trackingService, $q, $stateParams, $interval, $filter ,loadingService, remoteExceptionHandler, monitoringQueryService, spreadsheetExportService) {
            const TEMPERATURE = "br.com.neolog.tracking.model.api.SensorDataType.TEMPERATURE";
            const CONTAINER_DOOR = "br.com.neolog.tracking.model.api.SensorDataType.CONTAINER_DOOR";
            const queryName = "MonitorablesTemperatureSignals";
            $scope.$on("$destroy", function () {
                $interval.cancel($scope.reloadDataInterval);
            });
            $scope.model = {};
            $scope.sensors = [];
            $scope.canExport = false;
            $scope.temperatureConfig = {};
            $scope.accumulatedSignals = [];
            $scope.refreshTimesWithoutSignalsToInclude = 0;
            $scope.reloadDataIntervalUpdated = false;
            $scope.monitorableId = $stateParams.monitorableId;
            $scope.chartInput = {
                configs: {
                    chartTitle: "Temperatura X Tempo"
                },
                data: {
                    temperatures: [],
                    ranges: []
                },
                loadedData: false,
                chartControl: false,
                setData: function (temperatures, ranges) {
                    this.data.temperatures = temperatures;
                    this.data.ranges = ranges;
                    this.loadedData = true;
                },
                cleanData: function () {
                    this.data = {
                        temperatures: [],
                        ranges: []
                    };
                    this.loadedData = false;
                },
                refreshChartControl: function () {
                    this.chartControl = !this.chartControl;
                },
            };

            $scope.getMonitorableDevices = function () {
                return trackingService.findDeviceByMonitorableId($scope.monitorableId)
                    .catch(remoteExceptionHandler)
                    .then(function (devices) {
                        return devices;
                    });
            };

            $scope.loadChartData = function () {
                if (!($scope.model.sensor && $scope.model.device)) {
                    cleanAllData();
                    return;
                }
                $scope.canExport = true;
                $scope.reloadDataInterval = $interval(function () {
                    getSignalsAndRefreshChart(getCurrentPage());
                }, 20000);
                $q.resolve(monitoringService.getTemperatureRangeConfiguration($scope.model.sensor.temperatureRangeConfig.id))
                    .then(function (temperatureRangeConfig) {
                        $scope.temperatureConfig = temperatureRangeConfig;
                        getSignalsAndRefreshChart(getCurrentPage());
                    });
            };

            function getCurrentPage() {
                let countRecords = $scope.accumulatedSignals.length;
                if (countRecords == 0) {
                    return 0;
                }
                let maxPageSize = 1000;
                var currentPage = Math.round(countRecords / maxPageSize);
                return currentPage;
            }

            function getSignalsAndRefreshChart(currentPage) {
                if ($scope.refreshTimesWithoutSignalsToInclude > 4 && !$scope.reloadDataIntervalUpdated){
                    updateReloadDataInterval();
                    return;
                }
                return loadingService(trackingService.getSignalsByMonitorableAndDevicePageable($scope.monitorableId, $scope.model.device.deviceId, currentPage, 1000))
                    .then(function (signals) {
                        if (signals.length === 0){
                            return;
                        }
                        let signalsToInclude = _.filter(signals, function (s) {
                            return !_.some($scope.accumulatedSignals, s)
                        })
                        if (signalsToInclude.length === 0){
                            $scope.refreshTimesWithoutSignalsToInclude++;
                            return;
                        }
                        $scope.accumulatedSignals = $scope.accumulatedSignals.concat(signalsToInclude)
                        refreshChartData()
                    });
            }

            function updateReloadDataInterval() {
                $scope.reloadDataIntervalUpdated = true;
                $interval.cancel($scope.reloadDataInterval);
                $scope.reloadDataInterval = $interval(function () {
                    getSignalsAndRefreshChart(getCurrentPage());
                }, 90000);
            }

            function refreshChartData() {
                if (!($scope.temperatureConfig && $scope.accumulatedSignals)) {
                    return;
                }
                let temperatures = temperatureGraphPresentation($scope.accumulatedSignals);
                let ranges = rangeGraphPresentation($scope.temperatureConfig);
                $scope.chartInput.setData(temperatures, ranges);
                $scope.chartInput.refreshChartControl()
            }

            function temperatureGraphPresentation(signals) {
                var temperatures = [];
                signals.forEach(function (signal) {
                    signal.sensorData.forEach(function (sensor) {
                        if (sensor.configurationIdentifier !== $scope.model.sensor.identifier) {
                            return;
                        }
                        var doorOpenData = getDoorOpenData(sensor);
                        temperatures.push([sensor.temperature,
                            signal.signalTime,
                            doorOpenData]);
                    })
                });
                return temperatures;
            }

            function getDoorOpenData(sensor) {
                if ( sensor.sensorType === TEMPERATURE ) {
                    return null;
                }
                return sensor.containerDoorOpen;
            }

            function rangeGraphPresentation(config) {
                var ranges = [];
                var rawRanges = [config.centerRange,
                    config.lowerCriticalRange,
                    config.lowerWarningRange,
                    config.topCriticalRange,
                    config.topWarningRange];

                rawRanges.forEach(function (rawRange) {
                    var range = [];
                    range.push(rawRange.minTemperature);
                    range.push(rawRange.maxTemperature);
                    range.push(getColor(rawRange.temperatureRangeType));
                    ranges.push(range);
                });
                return ranges;
            }

            function getColor(rangeName) {
                if (rangeName.indexOf('CRITICAL') > -1) {
                    return 'red';
                }
                if (rangeName.indexOf('WARNING') > -1) {
                    return 'yellow';
                }
                return 'green';
            }

            $scope.deviceUpdate = function () {
                if (!$scope.model.device) {
                    cleanAllData()
                } else {
                    monitoringService.findSensorsByMonitorableIdAndDeviceIdAndProviderId($scope.monitorableId, $scope.model.device.deviceId, $scope.model.device.providerId)
                        .catch(remoteExceptionHandler)
                        .then(function (sensors) {
                            $scope.sensors = sensors;
                            $scope.hasSensors = !!$scope.sensors.length;
                        });
                }
            };

            $scope.formatTag = function (entity) {
                if (!entity) {
                    return "";
                }
                return entity.identifier.toString();
            };

            function cleanAllData() {
                $scope.chartInput.cleanData();
                $interval.cancel($scope.reloadDataInterval);
                $scope.canExport = false;
                $scope.model = {};
                $scope.temperatureConfig = {};
                $scope.sensors = [];
                $scope.hasSensors = false;
                $scope.accumulatedSignals = [];
            }

            $scope.temperatureReport = null;
            monitoringQueryService.getQuery(queryName)
                .then(function (report) {
                    $scope.temperatureReport = report;
                });

            $q.resolve(monitoringService.findMonitorableById($scope.monitorableId))
                .then(function (monitorable) {
                    $scope.monitorable = monitorable;
                });

            $scope.exportTemperatureSpreadsheet = function () {
                let headers = [
                    $translate.instant("title.monitoring.export.excel.deviceId"),
                    $translate.instant("title.monitoring.export.excel.providerId"),
                    $translate.instant("title.monitoring.export.excel.latitude"),
                    $translate.instant("title.monitoring.export.excel.longitude"),
                    $translate.instant("title.monitoring.export.excel.signalTime"),
                    $translate.instant("title.monitoring.export.excel.persistenceTime"),
                    $translate.instant("title.monitoring.export.excel.configurationIdentifier"),
                    $translate.instant("title.monitoring.export.excel.sensorType"),
                    $translate.instant("title.monitoring.export.excel.temperature"),
                    $translate.instant("title.monitoring.export.excel.containerDoorOpen")
                ]

            let reportName = $translate.instant("title.monitoring.export.excel.reportName") + " " + $scope.monitorable.sourceId
            return spreadsheetExportService.exportSpreadsheet(reportName, reportName, headers, $scope.convertToRows())
            };

            function getSensorType(sensor) {
                if (sensor.sensorType === 'br.com.neolog.tracking.model.api.SensorDataType.TEMPERATURE') {
                    return $translate.instant("title.monitoring.export.excel.sensorType.TEMPERATURE")
                }
                return $translate.instant("title.monitoring.export.excel.sensorType.CONTAINER_DOOR")
            }

            function getContainerDoorOpen(sensor) {
                if (!sensor.containerDoorOpen){
                    return $translate.instant("title.monitoring.export.excel.containerDoorOpen.close")
                }
                return $translate.instant("title.monitoring.export.excel.containerDoorOpen.open")
            }

            $scope.convertToRows = function () {
                return $scope.accumulatedSignals.flatMap(signal => signal.sensorData.map(sensor => {
                    let creationTimestamp = $filter("date")(signal.signalTime, "dd/MM/yyyy H:mm");
                    let persistenceTime = $filter("date")(signal.persistenceTime, "dd/MM/yyyy H:mm");
                    return [
                        signal.deviceId,
                        signal.providerId,
                        signal.latitude,
                        signal.longitude,
                        creationTimestamp,
                        persistenceTime,
                        sensor.configurationIdentifier,
                        getSensorType(sensor),
                        sensor.temperature,
                        getContainerDoorOpen(sensor)
                    ]
                }))
            };
        }
    ]);
});